import React from "react";

function MeetingUpdates(){
    return (
        <>
        <br></br>
        <h2 className="text-center">School Meeting Summaries</h2>
        <br></br>
        <div className="row">
<div class="card col" >
  <img src="https://blog.idrsolutions.com/wp-content/uploads/2020/10/pdf-1.png" class="card-img-top" alt="..."></img>
  <div class="card-body">
    <h5 class="card-title">August</h5>
    <p class="card-text">Find the summary and the minutes to our Monthly Administration Meetings!</p>
    <a href="#" class="btn btn-warning">View PDF</a>
  </div>
</div>
<br></br>
<div class="card col" >
  <img src="https://blog.idrsolutions.com/wp-content/uploads/2020/10/pdf-1.png" class="card-img-top" alt="..."></img>
  <div class="card-body">
    <h5 class="card-title">September</h5>
    <p class="card-text">Find the summary and the minutes to our Monthly Administration Meetings!</p>
    <a href="#" class="btn btn-warning">View PDF</a>
  </div>
</div>
<div class="card col" >
  <img src='https://blog.idrsolutions.com/wp-content/uploads/2020/10/pdf-1.png' class="card-img-top" alt="..."></img>
  <div class="card-body">
    <h5 class="card-title">October</h5>
    <p class="card-text">Find the summary and the minutes to our Monthly Administration Meetings!</p>
    <a href="#" class="btn btn-warning">View PDF</a>
  </div>
</div>
</div>
<br></br>
        <div className="row">
<div class="card col" >
  <img src="https://blog.idrsolutions.com/wp-content/uploads/2020/10/pdf-1.png" class="card-img-top" alt="..."></img>
  <div className="card-body">
    <h5 class="card-title">November</h5>
    <p class="card-text">Find the summary and the minutes to our Monthly Administration Meetings!</p>
    <a href="#" class="btn btn-warning">View PDF</a>
  </div>
</div>
<br></br>
<div class="card col" >
  <img src="https://blog.idrsolutions.com/wp-content/uploads/2020/10/pdf-1.png" class="card-img-top" alt="..."></img>
  <div class="card-body">
    <h5 class="card-title">December</h5>
    <p class="card-text">Find the summary and the minutes to our Monthly Administration Meetings!</p>
    <a href="#" class="btn btn-warning">View PDF</a>
  </div>
</div>
<div class="card col" >
  <img src="https://blog.idrsolutions.com/wp-content/uploads/2020/10/pdf-1.png" class="card-img-top" alt="..."></img>
  <div class="card-body">
    <h5 class="card-title">January</h5>
    <p class="card-text">Find the summary and the minutes to our Monthly Administration Meetings!</p>
    <a href="#" class="btn btn-warning">View PDF</a>
  </div>
</div>
</div>
        </>
    )
}

export default MeetingUpdates